var exports = {
  "N": "headerContainer__D3cN9R",
};

module.exports = exports;
